import Api from './rest/SpecOfferApi';

export default new Api();
